import { useMutation, useQueryClient } from 'react-query';

import * as companyService from 'resources/company/company.service';

export default function useCompanyUpdate() {
  const queryClient = useQueryClient();

  return useMutation(
    (requestData) => companyService.updateCompany(requestData),
    {
      onSuccess: (response) => {
        if (!response || response.isBadRequest) {
          return null;
        }

        queryClient.invalidateQueries('company.currentCompany');

        return response;
      },
    },
  );
}
